import { Component, Input } from '@angular/core';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    standalone: false
})
export class EmptyStateComponent {

    @Input() headline: string = 'No records found';
    @Input() hint: string = '';
    // `any` matches the repo-wide icon convention; duplicate @fortawesome/fontawesome-common-types
    // versions in node_modules make the IconDefinition types structurally incompatible.
    @Input() icon: any = faFolderOpen;

    /** Tightens spacing for nested/expanded-row tables. */
    @Input() compact: boolean = false;
}
